import React, { Component } from "react";
import { connect } from "react-redux";
import { Notice, NOTICE_TYPES } from "@appcues/component-library";

class FirebaseStatus extends Component {
  render() {
    const { firebase } = this.props;

    if (firebase.error) {
      return (
        <Notice type={NOTICE_TYPES.warning}>
          <b>Auto-saving failed</b>. Sorry about that! We're going to keep
          trying to save, but if the issue persists, please don't hesitate to
          contact us.
        </Notice>
      );
    }

    if (!firebase.online) {
      return (
        <Notice type={NOTICE_TYPES.primary}>
          <b>Seems you've lost your internet connection!</b> Feel free to
          continue working, but be aware that any changes you make will be lost
          if we are unable to re-connect before this tab closes.
        </Notice>
      );
    }

    return null;
  }
}

function mapStateToProps(state) {
  return {
    firebase: state.firebase
  };
}

export default connect(mapStateToProps)(FirebaseStatus);
